import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { catchError, tap } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Client } from './client.model';
import { CognitoService } from '../../services/cognito/cognito.service';
import { AwsSignerService } from '../../services/aws-signer/aws-signer.service';
import { Encoder } from '../../utils/encoder';
import { escape } from 'lodash';
@Injectable()
export class ClientService {
  hasJustRegistered: boolean;
  hasJustRegisteredElement: boolean;

  constructor(private http: HttpClient,
    private cognitoService: CognitoService,
    private awsSignerService: AwsSignerService) {

    this.hasJustRegistered = false;
    this.hasJustRegisteredElement = false;
  }

  getClientList(): Observable<any> {
    const awsHeaders = this.awsSignerService.getAwsHeader(this.getUrl(), 'GET');

    const headerParams = {
      'Content-Type': 'application/json',
      'Authorization': awsHeaders['Authorization'],
      'X-Amz-Date': awsHeaders['X-Amz-Date'],
      'x-api-key': environment.cesAPI.apiKey,
    };

    if (this.hasJustRegistered) {
      headerParams['Cache-Control'] = 'max-age=0';
    }

    const httpOptions = {
      headers: new HttpHeaders(headerParams)
    };

    return this.http.get<Array<Client>>(this.getUrl(), httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  saveClient(client: Client): Observable<any> {
    client.clientId = Encoder.encode(client.clientId);
    client.campaignId = Encoder.encode(client.campaignId);
    client.providerId = Encoder.encode(client.providerId);

    const jwtToken = this.cognitoService.getJwtToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': jwtToken,
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    return this.http.post<Client>(this.getUrl(), Client, httpOptions)
      .pipe(
        tap(() => this.hasJustRegistered = true),
        catchError(err => this.handleError(err))
      );
  }

  getClientById(clientId): Observable<any> {
    const encodedId = Encoder.encode(clientId);
    const awsHeaders = this.awsSignerService.getAwsHeader(`${this.getUrl()}/${encodedId}`, 'GET');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    return this.http.get<Client>(`${this.getUrl()}/${encodedId}`, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  updateClient(client: Client): Observable<any> {
    client.campaignId = Encoder.escape(client.campaignId);
    client.providerId = Encoder.escape(client.providerId);

    const urlUpdate = `${this.getUrl()}/${Encoder.encode(client.clientId)}`;
    const jwtToken = this.cognitoService.getJwtToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': jwtToken,
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    delete client.clientId;
    return this.http.put<Client>(urlUpdate, client, httpOptions)
      .pipe(
        tap(() => this.hasJustRegistered = true),
        catchError(err => this.handleError(err))
      );
  }


  private getUrl() {
    return `${localStorage.getItem('region-api')}/v1/test/clients`;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error && error.error.message === 'The security token included in the request is expired') {
      this.cognitoService.logout();
      return;
    }
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Something bad happened. Please try again later.');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/client/client.service.ts